// extracted by mini-css-extract-plugin
export default {"userLogo":"styles_userLogo__gihIY","pointerNone":"styles_pointerNone__pT9Xn","linkMenuItem":"styles_linkMenuItem__K0aPq"};